<!-- @veltra/icons generated sha256:1080ca0f4a331a8f gen:8 source:src/svg/normal/page-last.svg -->
<script setup lang="ts">
defineOptions({ name: 'PageLast' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m4.058 12.004.01.01c.254.254.65.241.904-.013l3.65-3.649a.497.497 0 0 0 0-.704l-3.65-3.65a.63.63 0 0 0-.914-.001.65.65 0 0 0-.006.92L7.135 8l-3.083 3.083a.65.65 0 0 0 .006.92m7.147-.66V4.657c0-.359-.272-.658-.63-.658h-.016a.66.66 0 0 0-.654.658v6.684a.66.66 0 0 0 .654.658h.015c.36 0 .63-.299.63-.658"
    />
  </svg>
</template>
